/*
 *   File : onboarding.js
 *   Description : v2 onboarding-session helpers.
 *                 A signup / mid-KYC user handed off from the login app (mw) arrives with
 *                 only an `onboarding_token` (no refresh/access token). These helpers let the
 *                 app recognise that session so it can render /kyc and skip the mPIN Unlock modal
 *                 (Unlock stays wired to the refreshToken-based session only).
 */

import Cookies from 'js-cookie';

export const ONBOARDING_TOKEN_KEY = 'onboarding_token';

// True only when the user holds an onboarding_token AND nothing stronger — no unlocked
// access_token session and no refreshToken login credential. The moment either of those
// exists it is a real (refreshToken-driven) session, so Unlock/normal auth resumes.
export const isOnboardingSession = () =>
    !!sessionStorage.getItem(ONBOARDING_TOKEN_KEY) &&
    !sessionStorage.getItem('access_token') &&
    !Cookies.get('refreshToken');

export const getOnboardingToken = () => sessionStorage.getItem(ONBOARDING_TOKEN_KEY);
